import { render } from "./contact.vue?vue&type=template&id=bfba2718&scoped=true"
const script = {}

import "./contact.vue?vue&type=style&index=0&id=bfba2718&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfba2718"]])

export default __exports__